import {
  JupiterTheme,
  MockHook,
  IntegrationInstanceItemsDisplay,
} from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { ListItemText } from '@material-ui/core';
import usePermissionListItemLogic, {
  PermissionListItemComponentProps,
} from './usePermissionListItemLogic';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    root: {},
    listItemRoot: {
      display: 'block',
      padding: theme.spacing(2, 0),
    },
    listItemText: {
      color: 'inherit',
      fontSize: '.8rem',
    },
    bold: {
      fontWeight: 'bold',
    },
  });
});

export const PermissionListItemComponent = ({
  permissionKey,
  permissionValue,
  instanceIds,
}: PermissionListItemComponentProps) => {
  const classes = useStyles();

  return (
    <ListItemText
      classes={{
        primary: `${classes.listItemText} ${classes.bold}`,
        secondary: classes.listItemText,
      }}
      primary={permissionKey}
      secondary={
        !instanceIds ? (
          permissionValue
        ) : (
          <IntegrationInstanceItemsDisplay instanceIds={instanceIds} />
        )
      }
      secondaryTypographyProps={{
        component: 'span',
      }}
    />
  );
};

export default MockHook.withHookHoc(
  PermissionListItemComponent,
  usePermissionListItemLogic
);
